import React from "react";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

const TeamFormInput = ({ name, control, label, errors, ...rest }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          label={label}
          error={!!errors[name]}
          helperText={errors[name]?.message || ""}
          margin="normal"
          className="w-100"
          {...rest}
        />
      )}
    />
  );
};

export default TeamFormInput;
